import React from 'react';

interface Props {
  search: string;
  onSearch: (val: string) => void;
  populationFilter: string;
  onPopulationFilter: (val: string) => void;
  onClear: () => void;
}

const Filters: React.FC<Props> = ({
  search,
  onSearch,
  populationFilter,
  onPopulationFilter,
  onClear,
}) => {
  return (
    <div className="flex justify-start mb-4">
      <div className="flex flex-col md:flex-row gap-4 items-center">
        <input
          type="text"
          placeholder="Search by country name"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          className="border px-4 py-2 rounded w-full md:w-64"
        />
        <select
          value={populationFilter}
          onChange={(e) => onPopulationFilter(e.target.value)}
          className="border px-4 py-2 rounded w-full md:w-40"
        >
          <option value="">All</option>
          <option value="<1M">&lt; 1M</option>
          <option value="<5M">&lt; 5M</option>
          <option value="<10M">&lt; 10M</option>
        </select>
        <button
          onClick={onClear}
          className="text-blue px-4 py-2 rounded"
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default Filters;
